// i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import your JSON data
import jsonData from './translation.json'; // Replace with the correct path

const resources = {
  en: {
    translation: jsonData, // Use your JSON data for the 'en' language
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'en', // Set the default language
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
